import { render, staticRenderFns } from "./NewMemberBody.vue?vue&type=template&id=e2f82fca&scoped=true&"
import script from "./NewMemberBody.vue?vue&type=script&lang=ts&"
export * from "./NewMemberBody.vue?vue&type=script&lang=ts&"
import style0 from "./NewMemberBody.vue?vue&type=style&index=0&id=e2f82fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f82fca",
  null
  
)

export default component.exports